import { Outlet } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { ForbiddenPage } from "@/pages/forbidden";

// Admin-only gate. Assumes <ProtectedRoute> sits above it, so `status` is
// already "authed" by the time this renders.
export function RequireAdmin() {
  const { user } = useAuth();
  if (!user || user.role !== "admin") {
    return <ForbiddenPage />;
  }
  return <Outlet />;
}
